import React from 'react';
import style from './style.module.scss';
import cs from 'classnames';
import {GalleryOverlayBar} from './GalleryOverlayBar';
import {ART} from './GalleryOverlayBar/ART';
import {ProductId} from './GalleryOverlayBar/ProductId';
import {Features} from './GalleryOverlayBar/Features';
import {FavouriteButton} from './GalleryOverlayBar/FavouriteButton';
import {IProductSnippet} from 'shared/types/productSnippet.types';

type TProductSnippetHeaderProps = Pick<
    IProductSnippet,
    'id' | 'isArt' | 'ratings' | 'reviewsCount' | 'reviewsUrl' | 'isFineAndRare' | 'wishlist' | 'stickers'
> &
    Pick<IProductSnippet['analytics'], 'onReviewsClick'>;

export const ProductSnippetHeader = (props: TProductSnippetHeaderProps) => {
    const {id, isArt, ratings, reviewsCount, reviewsUrl, isFineAndRare, wishlist, stickers, onReviewsClick} = props;

    return (
        <>
            <div className={style.headerSpacer} />
            <GalleryOverlayBar
                leftSlot={
                    <>
                        {isArt && (
                            <ART id={`${id}/tb`} place={'bottom-start'} className={cs(style.ART, style.ART_tablet)} />
                        )}
                        <ProductId id={id} className={cs({[style.hasArt]: isArt})} />
                        <Features
                            ratings={ratings}
                            stickers={stickers}
                            reviewsCount={reviewsCount}
                            reviewsUrl={reviewsUrl}
                            onReviewsClick={onReviewsClick}
                            isFineAndRare={isFineAndRare}
                        />
                    </>
                }
                centralSlot={isArt && <ART id={`${id}/dt`} />}
                rightSlot={<FavouriteButton {...wishlist} />}
            />
        </>
    );
};
